export const CHAT_MEDIA_MAX_SIZE_PX = 215;
export const CHAT_MEDIA_MAX_WIDTH_PX = 420;
export const CHAT_MEDIA_MAX_HEIGHT_PX = 300;
export const CHAT_VIDEO_MIN_WIDTH_PX = 150;
